export default __webpack_public_path__ + "static/Lato-Semibold-a354bb0b0b0f22de7befcfa340a45a84.woff";